import i18n from '@/libs/i18n'
import store from '@/store'
import useEntityCrud from '@/composable/useEntityCrud'
import useErrorManager from '@/composable/useErrorManager'
import { ref } from '@vue/composition-api'

export default function useCommentList() {
  function convertResource(resource) {
    return {
      ...resource,
      sender: { title: resource.title, status: resource.status },
    }
  }

  const ENDPOINT = 'units'
  const MODULE_NAME = 'units'
  const errorManager = useErrorManager()
  const entity = useEntityCrud(MODULE_NAME, ENDPOINT, convertResource)
  const { convertCollection, isSubmit, currentLanguage } = entity
  // Table Handlers
  const tableColumns = [
    { key: 'title', label: i18n.t('unit.unit'), icon: 'UserIcon' },
    { key: 'status', label: i18n.t('general.status'), icon: 'UserIcon' },
    {
      key: 'createdAt', label: i18n.t('general.createdAt'), sortable: true, type: 'dateTime',
    },
    {
      key: 'updatedAt', label: i18n.t('general.updatedAt'), sortable: true, type: 'dateTime',
    },
    { key: 'actions', label: i18n.t('general.actions'), sortable: false },
  ]

  const statusOptions = ref(['Published', 'Draft'])

  const fetchList = params => store
    .dispatch('crud/fetchList', {
      queryParams: {
        lang: currentLanguage.value,
        ...params,
      },
      endpoint: ENDPOINT,
    })
    .then(response => {
      const { data } = response
      return {
        data: convertCollection(data.data, currentLanguage.value),
        total: data.total,
      }
    })
    .catch(err => {
      errorManager(err)
    })

  return {
    ...entity,
    convertResource,
    fetchList,
    isSubmit,
    tableColumns,
    statusOptions,
  }
}
